export default __webpack_public_path__ + "static/media/monthToDate.cd4934c3.svg";